import React, { useState } from "react";
import styled, { css } from "styled-components/macro";
import { NavLink, Link } from "react-router-dom";
import LoadingImg from "../../assets/image/loader.svg";
import { LoginInput } from "./register";
import { Field } from "formik";
const ModalWrapper = styled.div`
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;
const Loading = ({ blur }) => (
  <ModalWrapper
    css={css`
      background: ${() => (blur ? "#fff" : "background: rgba(0, 0, 0, 0.5)")};
      position: absolute;
    `}
  >
    <img src={LoadingImg}></img>
  </ModalWrapper>
);
const Title = styled.h4`
  flex: 0 0 100%;
  max-width: 100%;
  font-size: 1.3rem;
  text-align: center;
  color: var(--color2);
  margin: 0 0 10px;
  padding: 0 10px;
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 20px;
`;
let Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0 60px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;
let InnerWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-content: flex-start;
  -webkit-overflow-scrolling: touch;
  padding: 5px 0;
`;
let NormalBtn = styled(NavLink)`
  height: inherit;
  font-size: 12px;
  padding: 10px 0;
  flex: 0 0 20%;
  max-width: 20%;
  text-align: center;
  color: #556e72;
  transition: 0.3s;
  &.active {
    color: var(--color1);
  }
`;

const BtnIcon = styled.i`
  font-size: 20px !important;
  color: #556e72;
  display: block !important;
  line-height: 20px !important;
  margin-bottom: 5px;
  transition: 0.3s;
  ${NormalBtn}.active & {
    color: var(--color1);
  }
`;
const HomeIcon = styled.i`
  font-size: 25px !important;
  color: var(--color1);
  display: block !important;
  width: 60px;
  position: absolute;
  line-height: 60px !important;
  top: -7px;
  left: calc(50% - 30px);
  border-radius: 50%;
  background: #fff;
  transition: 0.3s;
  box-shadow: 0 0 5px #949494;
  ${NormalBtn}.active & {
    background: var(--color1);
    color: #fff;
  }
`;
let Col = styled(({ size, ...props }) => <div {...props} />)`
  flex: 0 0 ${props => props.size}%;
  max-width: ${props => props.size}%;
  margin-bottom: 10px;
  padding: 0 7px;
`;
const ShadowedSection = styled.div`
  margin-bottom: 10px;
  background: #fff;
  box-shadow: 0 0 5px #bdbdbd;
  padding: 5px 8px;
  border-radius: 5px;
`;

function Input({ half, title, name, type, error, ...rest }) {
  const [state, setState] = useState(false);
  return (
    <div
      css={css`
        flex: 0 0 ${half ? "50%" : "100%;"};
        max-width: ${half ? "50%" : "100%;"};
        padding: 0 5px;
        margin-bottom: 10px;
        position: relative;
      `}
    >
      <LoginInput
        as={Field}
        name={name}
        type={type}
        placeholder={title}
        {...rest}
        css={css`
          transition: 0.2s;
          border-color: ${error ? "var(--failed)" : "var(--color1)"};
          padding-right: 5px;
          height: 45px;
          font-size: 14px !important;
        `}
      ></LoginInput>
      {error ? (
        <i
          className="md md-help-outline"
          onClick={() => {
            setState(!state);
          }}
          css={css`
            position: absolute;
            left: 5px;
            width: 30px;
            top: 0;
            bottom: 0;
            line-height: 50px !important;
            font-size: 1.5rem !important;
            color: var(--failed);
          `}
        ></i>
      ) : null}
      {error && state ? (
        <p
          css={css`
            position: absolute;
            background: var(--failed);
            left: 5px;
            right: 5px;
            bottom: -20px;
            margin: 0;
            z-index: 100;
            border-radius: 10px;
            color: #fff;
            font-size: 0.9rem;
            line-height: 25px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
          `}
        >
          {error}
        </p>
      ) : null}
    </div>
  );
}
const MainGrid = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  & > .content {
    width: inherit;
    height: calc(100% - 60px);
  }
`;
let DLayer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 20000;
  transform: translateZ(0);
  perspective: 1000;
`;
const Modal = ({ children, closable, isOpen, click }) => {
  return isOpen ? <DLayer onClick={click}>{children}</DLayer> : null;
};

const FooterContainer = styled.div`
  height: 60px;
  display: flex;
  flex-flow: wrap row;
  align-items: stretch;
  background: rgb(239, 244, 246);
  box-shadow: 0px 0px 3px #195591;
`;
const FooterButtons = styled(NavLink)`
  height: inherit;
  position: relative;
  font-size: 12px;
  flex: 1;
  text-align: center;
  color: rgb(85, 110, 114);
  padding: 10px 0px;
  transition: all 0.3s ease 0s;
  &.main {
    flex-grow: 0;
    flex-basis: 60px;
    flex-shrink: 0;
  }
  &.active,
  &.active.normal i {
    color: var(--color2);
  }
  &.normal i {
    font-size: 20px;
    color: rgb(85, 110, 114);
    margin-bottom: 5px;
    display: block !important;
    line-height: 20px !important;
    transition: all 0.3s ease 0s;
  }
  &.main i {
    position: absolute;
    font-size: 25px;
    color: rgb(255, 255, 255) !important;
    width: 60px;
    position: absolute;
    top: -7px;
    left: calc(50% - 30px);
    background: var(--color2);
    display: block !important;
    line-height: 60px !important;
    border-radius: 50%;
    transition: all 1s ease 0s;
  }
`;
export {
  Title,
  Loading,
  Container,
  InnerWrapper,
  NormalBtn,
  HomeIcon,
  BtnIcon,
  Col,
  ShadowedSection,
  Input,
  MainGrid,
  Modal,
  FooterContainer,
  FooterButtons
};
